import {
  Server,
  Globe,
  Smartphone,
  BarChart3,
  FlaskConical,
  BrainCircuit,
  Code,
} from 'lucide-react';

// Maps the icon name stored in personal.json features to a lucide-react icon.
const featureIconMap = {
  Server,
  Globe,
  Smartphone,
  BarChart3,
  FlaskConical,
  BrainCircuit,
};

// Returns the icon component for a given name, falling back to a generic Code icon.
export const getFeatureIcon = (name) => featureIconMap[name] || Code;

export default featureIconMap;
